"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.allColors = exports.brandColors = exports.colors = void 0;
exports.colors = {
    primaryBlue05: '#F0F6FF',
    primaryBlue10: '#C8E0FF',
    primaryBlue20: '#94C3FF',
    primaryBlue40: '#0064E5',
    primaryBlue50: '#004CAD',
    primaryBlue60: '#003880',
    primaryBlue80: '#002452',
    error05: '#FFF3F2',
    error20: '#FDB8AE',
    error50: '#FB5A47',
    error70: '#B50909',
    warning05: '#FFFAED',
    warning20: '#FFE396',
    warning50: '#FFBE2E',
    warning70: '#C18705',
    success05: '#F2FFFB',
    success20: '#BDECDD',
    success50: '#00A871',
    info05: '#F4F5FF',
    info20: '#B8C8FF',
    info50: '#617BFF',
    gray01: '#FBFCFD',
    gray02: '#F7F9FA',
    gray03: '#F5F6F7',
    gray04: '#F1F3F6',
    gray05: '#EDEFF0',
    gray10: '#DFE1E2',
    gray20: '#C6CACE',
    gray30: '#B2B9BD',
    gray40: '#99A0A7',
    gray50: '#7E888F',
    gray60: '#626B79',
    gray70: '#3D4551',
    gray80: '#2D2E2F',
    gray90: '#1C1D1F',
    accentPurple05: '#EBE2EE',
    accentPurple50: '#7B3C8C',
    accentPurple70: '#4E2759',
    accentBlue05: '#E2F4FC',
    accentBlue50: '#1E94D1',
    accentBlue70: '#015C8B',
    accentYellow05: '#FFEFD0',
    accentYellow50: '#FFBE2E',
    accentYellow70: '#86610E',
    dataBlue05: '#D3F2FF',
    dataBlue50: '#2FC0FF',
    dataBlue70: '#006896',
    dataPurple05: '#E8CBFF',
    dataPurple50: '#AE5DEE',
    dataPurple70: '#5D1099',
    dataYellow05: '#FFEFD0',
    dataYellow50: '#FFBE2E',
    dataYellow70: '#86610E',
    dataIndigo05: '#DFDEFF',
    dataIndigo50: '#5E5BFF',
    dataIndigo70: '#222092',
    dataGreen05: '#D2FFF4',
    dataGreen50: '#4EE4C0',
    dataGreen70: '#0C785E',
    pageBackground: '#FAFAFA',
    gray10000: '#AAA',
    gray11000: '#ccc',
    gray11100: '#E0E0E0',
    gray11110: '#eee',
    white: '#fff',
    teal50: '#12C0F2',
    black: '#000000',
};
const brandColorBasics = {
    blue: '#006CCF',
    accentBlue: '#024D95',
    white: '#FFFFFF',
    errorRed: '#C04226',
    accentErrorRed: '#88311E',
    transparent: 'transparent',
    accentCyan: '#00FFFF',
    neutralBackground: '#F2F1EC',
};
exports.brandColors = {
    primaryButton: {
        background: brandColorBasics.blue,
        border: brandColorBasics.blue,
        font: brandColorBasics.white,
        hoverBackground: brandColorBasics.accentBlue,
        hoverBorder: brandColorBasics.accentBlue,
        hoverFont: brandColorBasics.white,
    },
    secondaryButton: {
        background: brandColorBasics.white,
        border: brandColorBasics.blue,
        font: brandColorBasics.blue,
        hoverBackground: '#EAF5FF',
        hoverBorder: brandColorBasics.accentBlue,
        hoverFont: brandColorBasics.accentBlue,
    },
    tertiaryButton: {
        background: brandColorBasics.transparent,
        border: brandColorBasics.transparent,
        font: brandColorBasics.blue,
        hoverBackground: '#EAF5FF',
        hoverBorder: brandColorBasics.transparent,
        hoverFont: brandColorBasics.accentBlue,
    },
    cancelButton: {
        background: brandColorBasics.transparent,
        border: brandColorBasics.transparent,
        // TODO: follow up with design to see if this is still accurate
        font: '#4F4E4C',
        hoverBackground: brandColorBasics.neutralBackground,
        hoverBorder: brandColorBasics.transparent,
        hoverFont: '#333231',
    },
    dangerButton: {
        background: brandColorBasics.errorRed,
        border: brandColorBasics.errorRed,
        font: brandColorBasics.white,
        hoverBackground: brandColorBasics.accentErrorRed,
        hoverBorder: brandColorBasics.accentErrorRed,
        hoverFont: brandColorBasics.white,
    },
    dangerBorderlessButton: {
        background: brandColorBasics.transparent,
        border: brandColorBasics.transparent,
        font: brandColorBasics.errorRed,
        hoverBackground: '#FFEDE6',
        hoverBorder: brandColorBasics.transparent,
        hoverFont: brandColorBasics.accentErrorRed,
    },
    link: {
        font: brandColorBasics.blue,
    },
    neutralAlert: {
        background: brandColorBasics.neutralBackground,
        font: '#6E6D6A',
    },
    infoAlert: {
        background: '#F6EEFD',
        font: '#8157C0',
    },
    positiveAlert: {
        background: '#E1F5EB',
        font: '#1F7C53',
    },
    cautionAlert: {
        background: '#FEF1BA',
        font: '#87690B',
    },
    negativeAlert: {
        background: '#FFEDE6',
        font: '#C04226',
    },
    accentCyan: brandColorBasics.accentCyan,
    sideNav: {
        background: '#161515',
        backgroundHsl: '0 2% 8%',
        font: '#FFFFFF',
        hoverFont: '#242423',
        icon: '#8A8985',
        heading: '#8A8985',
        activeLinkAccent: brandColorBasics.accentCyan,
        activeLinkBackground: '#FFFFFF',
        activeLinkFont: '#242423',
    },
    formSideNav: {
        background: brandColorBasics.neutralBackground,
        font: '#4F4E4C',
    },
    table: {
        headerBackground: '#F7F6F4',
        headerOutline: '#E7E5DF',
        headerFont: '#6E6D6A',
        cellFont: '#333231',
    },
};
const allColors = () => Object.keys(exports.colors).map(color => ({
    name: color,
    hexCode: exports.colors[color],
}));
exports.allColors = allColors;
